var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscordLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 27,
    viewBox: "0 0 35 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5461 2.26124C27.2883 1.20487 24.8742 0.43715 22.3502 0C22.0403 0.56041 21.6781 1.31417 21.4285 1.91379C18.7455 1.5103 16.0871 1.5103 13.4535 1.91379C13.2039 1.31417 12.8335 0.56041 12.5208 0C9.9941 0.43715 7.57718 1.2077 5.31938 2.26684C0.765373 9.14854 -0.469143 15.8593 0.148116 22.4748C3.16857 24.7304 6.09576 26.1006 8.97355 26.9972C9.68409 26.0193 10.3178 24.9798 10.8637 23.8842C9.82399 23.4891 8.82815 23.0016 7.8872 22.4356C8.13683 22.2506 8.38101 22.0573 8.61691 21.8583C14.356 24.5427 20.5917 24.5427 26.2623 21.8583C26.501 22.0573 26.7451 22.2506 26.992 22.4356C26.0483 23.0044 25.0497 23.4919 24.01 23.887C24.5559 24.9798 25.1869 26.0221 25.9002 27C28.7807 26.1034 31.7106 24.7332 34.7311 22.4748C35.4554 14.8058 33.4939 8.15662 29.5461 2.26124ZM11.6456 18.4063C9.92277 18.4063 8.50991 16.798 8.50991 14.8394C8.50991 12.8808 9.8926 11.2696 11.6456 11.2696C13.3986 11.2696 14.8115 12.878 14.7813 14.8394C14.784 16.798 13.3986 18.4063 11.6456 18.4063ZM23.2336 18.4063C21.5108 18.4063 20.0979 16.798 20.0979 14.8394C20.0979 12.8808 21.4806 11.2696 23.2336 11.2696C24.9866 11.2696 26.3995 12.878 26.3693 14.8394C26.3693 16.798 24.9866 18.4063 23.2336 18.4063Z",
    fill: "#5865F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordLogo);
export default __webpack_public_path__ + "static/media/discord-logo.1a71ee9eb536fba955fc9f83ce8af687.svg";
export { ForwardRef as ReactComponent };